$(document).ready(function () {

    /* Banner slider js */

// $('.search-icon').click(function(){
//     $('.header_mobile_main').toggle();
// });

  
    $('#banneSlider').slick({
        autoplay: true,
        speed: 600,
        lazyLoad: 'progressive',
        arrows: true,
        dots: true,
        prevArrow: '<div class="slick-nav prev-arrow"><i></i><svg><use xlink:href="#circle"></svg></div>',
        nextArrow: '<div class="slick-nav next-arrow"><i></i><svg><use xlink:href="#circle"></svg></div>',
    }).slickAnimation();

    $('.slick-nav').on('click touch', function (e) {

        e.preventDefault();

        var arrow = $(this);

        if (!arrow.hasClass('animate')) {
            arrow.addClass('animate');
            setTimeout(() => {
                arrow.removeClass('animate');
            }, 1600);
        }
    });

    //  Mobile dropdown hide and show js
    $(document).ready(function () {
        $(".mobile-toggler-btn").click(function () {
            $(".sidebar-collapse").toggleClass("active");
            $(".x").toggleClass("toggle-active");
        });


    });

      // Sticky header js
      if ($(window).width() > 1200) {
        window.onscroll = function() { myFunction() };

        var header = document.getElementById("bottomHeader");
        var sticky = header.offsetTop;

        function myFunction() {
            if (window.pageYOffset > sticky) {
                header.classList.add("sticky");
            } else {
                header.classList.remove("sticky");
            }
        }
    }

});
